var map = {
	"./arrow-down-blue.svg": 487,
	"./arrow-down-grey.svg": 488,
	"./arrow-right-white.png": 489,
	"./arrow-right.svg": 490,
	"./avalanche_token_round.png": 179,
	"./big_unicorn.png": 263,
	"./blue-loader.svg": 133,
	"./check.svg": 491,
	"./circle-grey.svg": 492,
	"./circle.svg": 493,
	"./clock.svg": 494,
	"./coinbaseWalletIcon.svg": 495,
	"./dropdown-blue.svg": 496,
	"./dropdown.svg": 497,
	"./dropdown2.svg": 267,
	"./dropup-blue.svg": 498,
	"./ethereum-logo.png": 499,
	"./fortmaticIcon.png": 500,
	"./infinity.svg": 501,
	"./link.svg": 502,
	"./magnifying-glass.svg": 503,
	"./menu.svg": 504,
	"./metamask.png": 266,
	"./multiple.svg": 505,
	"./noise.png": 265,
	"./plus-blue.svg": 506,
	"./plus-grey.svg": 507,
	"./portisIcon.png": 508,
	"./price-tags.svg": 509,
	"./question-mark.svg": 510,
	"./question.svg": 511,
	"./single.svg": 512,
	"./spinner.svg": 513,
	"./token-list/lists-dark.png": 514,
	"./token-list/lists-light.png": 515,
	"./token-logo.png": 516,
	"./trustWallet.png": 517,
	"./walletConnectIcon.svg": 518,
	"./x.svg": 519,
	"./xl_uni.png": 264
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 237;